/**
 * TICK-160 — the event date decides when every ticket link expires (end of that day + 3 days), and the
 * free-text label shown to buyers does not. On staging, `jocho-rock` carried an end date in 2024 while
 * selling in 2026, and the link it emailed had expired before it was sent. Warned, not refused: deciding whether past-dated events
 * may exist at all is a business rule nobody has made yet.
 */
export function pastDateWarning(date: string, today: Date = new Date()): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return '';
  const year = Number(date.slice(0, 4));
  if (year >= today.getFullYear() + 400) {
    return `ปี ${year} ดูเหมือนเป็น พ.ศ. — ช่องนี้ใช้ ค.ศ. (เช่น ${year - 543})`;
  }
  const local = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  if (date < local) {
    return 'วันจัดงานอยู่ในอดีต — ลิงก์ตั๋วใช้ได้ถึง 3 วันหลังวันจัดงานเท่านั้น ถ้าเลยมาแล้ว ผู้ซื้อจะได้ลิงก์ที่เปิดไม่ได้ · ตรวจปี ค.ศ. ให้ถูกก่อนสร้าง';
  }
  return '';
}
